import { useTeamField } from '@atlassian/jira-issue-field-team/src/services';
import { TEAMS_PLATFORM_CF_TYPE } from '@atlassian/jira-platform-field-config';
import { useGenericClipboardHandler } from '../../../clipboard-handler/utils';
import type {
	ClipboardItem,
	ListIssueFieldTransformed,
	PasteHandler,
	PasteMetadata,
} from '../../../types';
import { createClipboardHelperComponent } from '../../utils';
import type { TransformedTeamOption } from '../types';

const isTransformedTeamOption = (fieldValue: unknown): fieldValue is TransformedTeamOption =>
	fieldValue != null &&
	typeof fieldValue === 'object' &&
	'id' in fieldValue &&
	'name' in fieldValue;

const getPastedValue = (
	clipboardItem: ClipboardItem,
	metadata: PasteMetadata | null,
): TransformedTeamOption | null => {
	if (!clipboardItem || !metadata?.fieldValue) {
		return null;
	}

	if (!isTransformedTeamOption(metadata.fieldValue)) {
		return null;
	}
	const { id, name } = metadata.fieldValue;

	return { id, name };
};

const useTeamClipboardHandler: PasteHandler = (
	issue: { key: string },
	field: ListIssueFieldTransformed,
) => {
	const [, { saveValue }] = useTeamField({
		issueKey: issue.key,
		fieldKey: field?.fieldId,
	});

	return useGenericClipboardHandler(field, getPastedValue, saveValue);
};

const TeamClipboardHelper = createClipboardHelperComponent(useTeamClipboardHandler);

export const teamClipboardHandler = {
	[TEAMS_PLATFORM_CF_TYPE]: TeamClipboardHelper,
};
